module.exports = __webpack_public_path__ + "69d298179c0fe8cabe17ad556343780e.svg";